export const XL_BREAKPOINT_WIDTH = 1200;
